interface Array<T> {
    equals(array);
}
interface String {
    equals(string);
}
enum AxisLabelDisplayModeEnum {
    Standard = 0,
    Rotate = 1,
    Stagger = 2,
}

enum BubbleScatterType {
    YAxis = 0,
    XAxis = 1,
    //Only for Bubble
    BubbleSize = 2,
}

enum ChartStatus {
    Ready = "Ready",
    Starting = "Starting",
    ChangingProperties = "ChangingProperties",
    Rendering = "Rendering",
}
enum LegendPositionEnum {
    None = "none",
    Top = "top",
    Bottom = "bottom",
    Left = "left",
    Right = "right",
}

enum ChartType {
    Line = 0,
    Bar = 1,
    StackedBar = 2,
    Pie = 3,
    Donut = 4,
    Polar = 5,
    StackedArea = 6,
    Radar = 7,
    RadarArea = 8,
    Area = 9,
    HorizontalBar = 10,
    HorizontalBarStacked = 11,
    Mixed = 12,
    Bubble = 13,
    Scatter = 14
}

enum DxChartType {
    Spline = "spline",
    Bar = "bar",
    StackedBar = "stackedbar",
    Pie = "pie", //dxPieChart
    Doughnut = "doughnut", //dxPieChart
    None = "", //polar dxPolarChart //radar dxPolarChart //radar area dxPolarChart //mixed
    StackedSplineArea = "stackedsplinearea",
    SplineArea = "splinearea",
    Bubble = "bubble",
    Scatter = "scatter"
}